import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams, Link } from "react-router-dom"
import { FaAngleLeft } from 'react-icons/fa'
import Alert from 'react-bootstrap/Alert'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import { apiURL, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const MuseumArchive = () => {
    const [currentUser, setCurrentUser] = useState()
    const [museum, setMuseum] = useState({})
    const [buildings, setBuildings] = useState([])
    const [filteredBuildings, setFilteredBuildings] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const [loadError, setLoadError] = useState('')
    const navigate = useNavigate()
    const { entityId } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            await getMuseum()
            await getBuildings()
        }
        start()
    }, [])

    useEffect(() => {
        search(searchValue)
    }, [searchValue])

    const getMuseum = async () => {
        try {
            const response = await axios.get(`${apiURL}/get-museum/${entityId}`)

            if (!response.data.success) {
                setLoadError("Cannot load museum data: " + (response.data.error || response.data))
                return
            }

            setMuseum(response.data.item)
        } catch (error) {
            setLoadError(JSON.stringify(error))
        }
    }

    const getBuildings = async () => {
        const response = await axios.get(`${apiURL}/get-buildings/${entityId}`)
        setBuildings(response.data.rows)
        setFilteredBuildings(response.data.rows)
    }

    const search = (str) => {
        if (!buildings || !buildings.length) {
            return
        }

        if (!str) {
            setFilteredBuildings(buildings)
            return
        }

        const lowerValue = removeAccents(str.toLowerCase())
        const filteredRows = buildings.filter(row => removeAccents(Object.values(row).join('').toLowerCase()).includes(lowerValue))
        setFilteredBuildings(filteredRows)
    }

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    const addBuilding = () => {
        navigate(`/museum/${museum.id}/archive/buildings/new`)
    }

    const viewBuilding = (id) => {
        const building = buildings.find(x => x.id === id)
        navigate(`/museum/${museum.id}/archive/buildings/${building.id}`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <main className="full-width">
                {museum.id &&
                    <>
                        <div>
                            <Link to={`/museum/${museum.id}/archive`} className="no-decoration"><FaAngleLeft /> Back to Archive</Link>
                        </div>
                        <header className="mt-2">
                            <div className="float-start">
                                <h1>Buildings</h1>
                            </div>
                        </header>
                    </>
                }
                {filteredBuildings
                    ? <>
                        <Form.Control
                            placeholder="Building quick search"
                            onChange={e => setSearchValue(e.target.value)}
                        />
                        <div className="py-2 pl-4">
                            <small className="float-end text-secondary">
                                {filteredBuildings.length === buildings.length
                                    ? <>{filteredBuildings.length} buildings</>
                                    : <>{filteredBuildings.length}/{buildings.length} buildings</>
                                }
                            </small>
                        </div>
                        <Row>
                            {filteredBuildings.map(building =>
                                <Col md="6" lg="3" key={`col-${building.id}`}>
                                    <Card className="listItem clickable mb-4" onClick={() => viewBuilding(building.id)}>
                                        <div className="headerImage" style={{backgroundImage: `url(${filesURL}/${building.mainImage})`}}></div>
                                        <Card.Body>
                                            <Card.Title>{building.name}</Card.Title>
                                            <Card.Text>{building.description}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                      </>
                    : <>No buildings found.</>
                }
                {loadError &&
                    <>
                        <Alert key='loadError' variant='danger'>
                            {loadError}
                        </Alert>
                    </>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default MuseumArchive